import React from 'react';
import { HiOutlineSun, HiOutlineMoon, HiOutlineMenu, HiOutlineHome } from 'react-icons/hi';
import { useChowaTheme } from './chowaThemeContext';
import ChowaUserMenu from './ChowaUserMenu';
import { Link } from 'react-router-dom';

const ChowaHeader = ({ toggleSidebar }) => {
  const { isDark, toggleTheme, getCurrentTheme, isSeriesSelected } = useChowaTheme();
  const currentTheme = getCurrentTheme();

  return (
    <header 
      className="h-[62px] flex items-center justify-between px-2 sm:px-4 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 transition-colors duration-200"
      style={{
        // シリーズ選択時のみアクセントカラーをボーダーに適用
        borderBottomColor: isSeriesSelected ? currentTheme.primary : undefined,
        // ボーダー位置を微調整
        borderBottomWidth: '1.5px'
      }}
    >
      {/* 左側：ハンバーガーメニューとTOPPAGEボタン */}
      <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
        <button
          onClick={toggleSidebar}
          className="lg:hidden p-1 sm:p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
          style={{
            // シリーズ選択時はシリーズカラーでホバー
            '--hover-bg': isSeriesSelected ? `${currentTheme.light}20` : undefined
          }}
          aria-label="Toggle Sidebar"
        >
          <HiOutlineMenu className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600 dark:text-gray-300" />
        </button>
        
        {/* TOPPAGEに戻るボタン */}
        <Link
          to="/"
          className="p-1 sm:p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center transition-colors duration-200"
          aria-label="Back to Top Page"
        >
          <HiOutlineHome className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600 dark:text-gray-300" />
          <span className="ml-1 text-gray-600 dark:text-gray-300 hidden sm:inline">トップページ</span>
        </Link>
      </div>

      {/* 右側：テーマ切り替え、ユーザーメニュー（カラー選択は削除） */}
      <div className="flex items-center space-x-2">
        {/* テーマ切り替え */}
        <button
          onClick={toggleTheme}
          className="p-1 sm:p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 flex-shrink-0 transition-colors duration-200"
          style={{
            // シリーズ選択時はシリーズカラーでホバー
            '--hover-bg': isSeriesSelected ? `${currentTheme.light}20` : undefined
          }}
        >
          {isDark ? (
            <HiOutlineSun 
              className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600 dark:text-gray-300"
              style={{
                color: isSeriesSelected ? currentTheme.primary : undefined
              }}
            />
          ) : (
            <HiOutlineMoon 
              className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600 dark:text-gray-300"
              style={{
                color: isSeriesSelected ? currentTheme.primary : undefined
              }}
            />
          )}
        </button>

        {/* ユーザーメニュー */}
        <div className="flex-shrink-0">
          <ChowaUserMenu />
        </div>
      </div>

      {/* 追加のスタイル：ホバー効果をカスタムカラーで適用するためのCSS */}
      <style>{`
        [data-chowa-app] header button:hover {
          background-color: ${isSeriesSelected ? `${currentTheme.light}20` : ''} !important;
        }
      `}</style>
    </header>
  );
};

export default ChowaHeader; 